<script src="https://static.line-scdn.net/liff/edge/2/sdk.js"></script>
<script src="https://ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js"></script>
<?php
    session_start();
?>
<template>
  <v-container>
    <v-layout text-center wrap>
      <v-flex xs12>
        <h3><v-btn large color="success" @click="loginAction">現在のＬＩＮＥログインを使用して継続</v-btn></h3>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
// for HTTP response
import axios from 'axios';
// for encrypt message
import crypto from 'crypto-js';
var CryptoJS = require('crypto-js');
// var dts = new Date().getDate();
var dts = '651127';
var passPhrase = "45b54c392cc235a79ce573f623b2f8023" + dts + "d6dd6edf2488805962a3d223be6566b";
const salt = CryptoJS.lib.WordArray.random(128 / 8);
const iv = CryptoJS.lib.WordArray.random(128 / 8);
const key = "0921b90b3b7dab492b4aa897e3d0ccffde0f59579fc0c6229213c" + dts + "94822466ce8";

export default {
  created () {
    this.initializeLiff()
  },
  mounted() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        function(position){
          let coords = position.coords;
          let tmp_lat = coords.latitude;
          let tmp_lng = coords.longitude;
        }.bind(this),
        function(error) {
          // エラー処理を書く
        }
      );
    } else {
      // エラー処理を書く
    }
  },
  methods: {
    initializeLiff: function () {
      var me = this
      liff.init(
        {
          liffId: process.env.VUE_APP_LIFF_ID
        },
        data => {
          // LINE(LIFF)ログインOKの場合、QueryString[mlno] と QueryString[start] を取得して値に応じてページを遷移させる
          if (liff.isLoggedIn()) {
            if (this.$route.query.start) {
               if(this.$route.query.start==1){
                me.$router.push({ name: 'stores' })
               }else if(this.$route.query.start==2){
                me.$router.push({ name: 'recomendation' })
               }else if(this.$route.query.start==3){
                //?start=3の場合はトップ画面に遷移（main.jsの設定でmobileorder=1になっている前提）
                me.$router.push({ name: 'login' })
               }else if(this.$route.query.start==4){
                me.$router.push({ name: 'mobileorder' })
               }else if(this.$route.query.start==5){
                me.$router.push({ name: 'purchases' })
               }else if(this.$route.query.start==6){
                //push_message_list
                me.$router.push({ name: 'pm_list' })
               }else if(this.$route.query.start==7){
                //push_message_detail
                me.$router.push({ name: 'pm_detail' })
               }else{
                me.$router.push({ name: 'login' })
               }
            }else{
                me.$router.push({ name: 'login' })
            }
          }
        },
        err => {
          console.log('LIFF initialization failed', err)
        }
      )
    },
    loginAction: function () {
      this.initializeLiff();
      // ログインまだ
      if (!liff.isLoggedIn()) {
        liff.login()
      }
    }
  }
}
</script>
